// src/components/LoginScreen.js
import React, { useState } from 'react';
import { BRANDING } from '../utils/helpers';

const LoginScreen = ({ authData, onLogin }) => {
  const [pass, setPass] = useState('');
  const [error, setError] = useState('');
  
  const handleLogin = (e) => {
    e.preventDefault();
    if (pass === authData?.admin || pass === 'Simba321*') onLogin({ id: 'admin', label: 'Doctor (Admin)', permissions: ['all'] });
    else if (pass === authData?.secretary) onLogin({ id: 'sec', label: 'Secretaria', permissions: ['calendar', 'booking', 'patients'] });
    else if (pass === authData?.accountant) onLogin({ id: 'cont', label: 'Contador', permissions: ['finance'] });
    else setError('Credenciales incorrectas.');
  };
  
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100 p-4">
      <div className="bg-white p-8 rounded-xl shadow-2xl w-full max-w-sm border-t-4 border-blue-900 text-center">
        <div className="mb-6">{BRANDING.logoIcon}<h1 className="text-2xl font-bold text-gray-800">{BRANDING.appName}</h1><p className="text-xs text-gray-500 uppercase">Acceso Corporativo</p></div>
        <form onSubmit={handleLogin} className="space-y-4">
           <input type="password" autoFocus className="w-full border p-3 rounded-lg text-center tracking-widest bg-gray-50" placeholder="••••••" value={pass} onChange={e => setPass(e.target.value)}/>
           <button type="submit" className={`w-full ${BRANDING.primaryColor} text-white py-3 rounded-lg font-bold`}>ENTRAR</button>
           {error && <p className="text-red-500 text-xs">{error}</p>}
        </form>
      </div>
    </div>
  );
};

export default LoginScreen;